import { Dispatch } from 'redux'

import { getAll } from 'redux/api/Categories'

import * as actions from './actions'

export function tryGetAllCategories(dispatch: Dispatch) {
  dispatch(actions.getAll())

  getAll()
    .then((response) => {
      dispatch(actions.getAllSuccess(response.data.data))
    })
    .catch(() => {
      dispatch(actions.getAllFailed())
    })
}
